export type AppEnv = 'development' | 'test' | 'production'

const useH5Proxy = __UNI_PLATFORM__ === 'h5'
  && import.meta.env.DEV
  && import.meta.env.VITE_APP_PROXY === 'true'

/**
 * 应用环境配置统一入口。
 *
 * mode 决定后端环境，UNI_PLATFORM 仅用于处理平台差异。
 * H5 只有在 dev server 中才使用代理前缀，构建产物始终使用完整域名。
 */
export const envConfig = {
  appEnv: import.meta.env.VITE_APP_ENV as AppEnv,
  serverBaseUrl: import.meta.env.VITE_SERVER_BASEURL,
  authServerBaseUrl: import.meta.env.VITE_SERVER_AUTH_BASEURL,
  staticServerBaseUrl: import.meta.env.VITE_SYS_STATIC_BASEURL,
  timeServerBaseUrl: import.meta.env.VITE_TIME_SERVER_BASEURL,
  uploadBaseUrl: import.meta.env.VITE_UPLOAD_BASEURL,
  secondaryApiBaseUrl: import.meta.env.VITE_API_SECONDARY_URL,
  requestBaseUrl: useH5Proxy
    ? import.meta.env.VITE_APP_PROXY_PREFIX
    : import.meta.env.VITE_SERVER_BASEURL,
  authRequestBaseUrl: useH5Proxy
    ? import.meta.env.VITE_APP_PROXY_AUTH_PREFIX
    : import.meta.env.VITE_SERVER_AUTH_BASEURL,
  timeRequestUrl: useH5Proxy
    ? `${import.meta.env.VITE_APP_PROXY_TIME_PREFIX}/ts`
    : `${import.meta.env.VITE_TIME_SERVER_BASEURL}/ts`,
  remoteAppSettingUrl: useH5Proxy
    ? `${import.meta.env.VITE_APP_PROXY_STATIC_PREFIX}/wx/mp-system/app-setting-conf/appSetting.json`
    : `${import.meta.env.VITE_SYS_IMG_BASE_URl}app-setting-conf/appSetting.json`,
  useH5Proxy,
} as const
